module.exports = __webpack_public_path__ + "static/media/ex-why-coose-img.ec2a4395.svg";